import { useEffect } from 'react';
import { Button, Dimmer, Header, Message } from 'semantic-ui-react';
import {
	Redirect,
	Route,
	Switch,
	Link,
	useLocation,
	useRouteMatch,
} from 'react-router-dom';
import { LoginForm, LoginFormFields } from '../LoginForm/LoginForm';
import { Logo } from '../Logo/Logo';
import { SimpleFormWrapper } from '../SimpleFormWrapper/SimpleFormWrapper';
import { Spinner } from '../Spinner/Spinner';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../../types/app-state';
import { AuthState } from '../../types/auth-state';
import { Login } from '../../actions/auth.actions';
import { PreselectOrganisation } from '../../actions/organisation.actions';
import './LoginPage.less';

export const LoginPage: React.FC = () => {
	const location = useLocation();
	const dispatch = useDispatch();
	const match = useRouteMatch();
	const { email, token, login_loading: loading, message } = useSelector<
		AppState,
		Partial<AuthState>
	>((state) => state.auth);
	const isAuthenticated = !!token;
	const { from } = (location.state as any) || { from: { pathname: '/' } };

	const onSubmit = (values: LoginFormFields) => {
		dispatch(Login(values.email, values.password));
	};

	useEffect(() => {
		const searchParams = new URLSearchParams(window.location.search);
		const fromURL = searchParams.get('from');
		const tenantId = searchParams.get('tenantId');

		if (fromURL) {
			sessionStorage.setItem('msp_loggedoutfrom', fromURL);
		}

		if (tenantId) {
			dispatch(PreselectOrganisation(tenantId));
		}
	}, [dispatch]);

	if (isAuthenticated) {
		return <Redirect to={from} />;
	}

	return (
		<div className='login-page'>
			<Dimmer inverted active={loading}>
				<Spinner />
			</Dimmer>
			<SimpleFormWrapper>
				<Logo />
				<LoginForm
					defaultEmail={email}
					onSubmit={onSubmit}
					renderActionButtons={() => (
						<div className='form-buttons'>
							<Button fluid primary type='submit'>
								Login
							</Button>
							<Button as={Link} to={'/forgotpassword'} fluid color='grey'>
								Forgot or don’t have a password
							</Button>
						</div>
					)}
				>
					<Switch>
						<Route
							path={match.url + '/:name'}
							render={(routeProps) => (
								<div className='with-domain'>
									<p>Login to</p>
									<Header as='h3'>
										{routeProps.match.params.name}.myspendingplanner.com.au
									</Header>
								</div>
							)}
						/>
					</Switch>
					{message && (
						<Message negative>
							<p>{message}</p>
						</Message>
					)}
				</LoginForm>
			</SimpleFormWrapper>
		</div>
	);
};

export default LoginPage;
